/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FlagAIcon32Regular = forwardRef('FlagAIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 31a1 1 0 1 0 2 0v-8h21.718c1.142 0 1.803-1.294 1.135-2.22L23.233 13l5.62-7.78C29.52 4.294 28.86 3 27.718 3H7a3 3 0 0 0-3 3v25ZM7 5a1 1 0 0 0-1 1v15h20.544l-5.355-7.415a1 1 0 0 1 0-1.17L26.544 5H7Z" })));
});
